export default "__VITE_ASSET__x$zvamsd__"